import { Icon } from '@iconify/react';
// routes
import { PATH_AUTH, PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  user: <Icon icon="ic:baseline-security" style={{ fontSize: '25px' }} />,
  deposit: getIcon('ic_ecommerce'),
  product: <Icon icon="mdi-light:home" style={{ fontSize: '25px' }} />,
  users: <Icon icon="mdi-light:account" style={{ fontSize: '25px' }} />,
  branches: <Icon icon="mdi-light:briefcase" style={{ fontSize: '25px' }} />,
  logout: <Icon icon="mdi-light:logout" style={{ fontSize: '25px' }} />,
  reports: <Icon icon="mdi-light:chart-bar" style={{ fontSize: '25px' }} />,
  withdraw: <Icon icon="uil:money-withdrawal" style={{ fontSize: '25px' }} />,
  friendlyTransfer: <Icon icon="fa6-solid:money-bill-transfer" style={{ fontSize: '25px' }} />,
  memberTier: <Icon icon="carbon:skill-level-intermediate" style={{ fontSize: '25px' }} />,
  faq: <Icon icon="wpf:faq" style={{ fontSize: '25px' }} />,
  contactUS: <Icon icon="healthicons:contact-support" style={{ fontSize: '25px' }} />
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Main',
    items: [{ title: 'Products', path: PATH_DASHBOARD.general.product, icon: ICONS.product }]
  },
  {
    subheader: 'Additionall',
    items: [
      { title: 'Users', path: PATH_DASHBOARD.general.users, icon: ICONS.users },
      { title: 'Branches', path: PATH_DASHBOARD.general.branch, icon: ICONS.branches }
    ]
  },
  {
    subheader: 'Reports',
    items: [
      {
        title: 'Reports',
        path: PATH_DASHBOARD.app.root,
        icon: ICONS.reports,
        children: [
          { title: 'Products', path: PATH_DASHBOARD.report.product },
          { title: 'Summary', path: PATH_DASHBOARD.report.productSummary }
        ]
      }
    ]
  },
  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'Settings',
    items: [
      {
        title: 'Settings',
        path: PATH_DASHBOARD.app.root,
        icon: ICONS.user,
        children: [{ title: 'Emails', path: PATH_DASHBOARD.settings.email }]
      }
    ]
  },
  {
    subheader: 'Security',
    items: [
      {
        title: 'Logout',
        path: PATH_AUTH.logout,
        icon: ICONS.logout
      }
    ]
  }
];

export default sidebarConfig;
